import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { CreneauxEnConflit } from 'src/app/utils/interfaces/new/CreneauxEnConflit';
import { environment } from 'src/environments/environment';

interface Conflict {
  id: string;
  dateDebut: Date;
  dateFin: Date;
  visibleParProfil: boolean;
  description?: string;
  ressourceName: Array<string>;
}

@Component({
  selector: 'app-event-conflict',
  templateUrl: './event-conflict.component.html',
  styleUrls: [
    './event-conflict.component.scss',
    '../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class EventConflictComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  public explication = '';
  public conflictsList: Array<CreneauxEnConflit> = [];
  public cancelLabel = 'Ne rien faire';
  public validateLabel = 'Enregistrer malgré tout';
  public conflictsDisplay: Array<Conflict> = [];

  constructor() { }

  ngOnInit(): void {
    this._initConflictsDisplay();
  }

  public closeModal(doForceSave = false): void {
    this.closeEmitter.emit(doForceSave);
  }

  private _initConflictsDisplay(): void {
    for (const c of this.conflictsList) {
      const conflict = this.conflictsDisplay.find(cd => cd.id === c.id);
      if (conflict) {
        conflict.ressourceName.push(c.ressourceName);
      } else {
        this.conflictsDisplay.push({
          dateDebut: c.dateDebut,
          dateFin: c.dateFin,
          id: c.id,
          ressourceName: [c.ressourceName],
          visibleParProfil: c.visibleParProfil,
          description: c.description
        });
      }
    }
  }

}
